export const skillArray = [
    {
        title: "Frontend",
        skills: [
            "HTML",
            "CSS",
            "SCSS",
            "JavaScript",
            "TypeScript",
            "React.js",
            "Redux",
            "Figma"
        ]
    },
    {
        title: "Backend",
        skills: [
            "Node.js",
            "Express.js",
            "SQLite",
            "PostgreSQL",
            "MongoDB",
            "Firebase",
            "Swagger"
        ]
    },
    {
        title: "Additional Skills",
        skills: [
            "Stripe",
            "Jest Testing Framework",
            "AWS",
            "Python",
            "Git"
        ]
    }
];